import { render } from "./SurveyStat.vue?vue&type=template&id=534dedef&scoped=true"
import script from "./SurveyStat.vue?vue&type=script&lang=js"
export * from "./SurveyStat.vue?vue&type=script&lang=js"

import "./SurveyStat.vue?vue&type=style&index=0&id=534dedef&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534dedef"]])

export default __exports__